import React from 'react';
import PropTypes from 'prop-types';
import PostCodeComponent from './components/PostCodeComponent';
import LocalAddressComponent from './components/LocalAddressComponent';
import SelectAddressComponent from './components/SelectAddressComponent';
import AddManuallyComponent from './components/addManuallyComponent';

const AddressPostCodeComponentPage = ({
  type,
  onFindAddressClick,
  onAddManuallyClick,
  formValues,
  isPostCodeListError,
  isAddMunuallyClicked,
  onSelectAddressClick,
  postCodeAddressList,
  currentIndex
}) => {
  return (
    <div>
      {!isAddMunuallyClicked && (
        <PostCodeComponent
          type={type}
          onFindAddressClick={onFindAddressClick}
          onAddManuallyClick={onAddManuallyClick}
          isAddMunuallyClicked={isAddMunuallyClicked}
          isPostCodeListError={isPostCodeListError}
          formValues={formValues}
          postCodeAddressList={postCodeAddressList}
        />
      )}
      <AddManuallyComponent
        type={type}
        onAddManuallyClick={onAddManuallyClick}
        isAddMunuallyClicked={isAddMunuallyClicked}
      />
      {isAddMunuallyClicked && <LocalAddressComponent type={type} />}
      {!isAddMunuallyClicked && postCodeAddressList && postCodeAddressList.length > 0 && (
        <SelectAddressComponent
          type={type}
          onSelectAddressClick={onSelectAddressClick}
          isAddMunuallyClicked={isAddMunuallyClicked}
          postCodeAddressList={postCodeAddressList}
          currentIndex={currentIndex}
          formValues={formValues}
        />
      )}
    </div>
  );
};

AddressPostCodeComponentPage.propTypes = {
  type: PropTypes.string,
  postAddressList: PropTypes.array,
  onFindAddressClick: PropTypes.func.isRequired,
  onAddMauallyClick: PropTypes.func.isRequired
};

export default AddressPostCodeComponentPage;
